export const SOMETHING_WENT_WRONG =
  "Something went wrong, Please try again later.";
